import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import bookingActions from 'actions/bookings/actions'
import Table from 'components/shared/table/table'
import THead from 'components/shared/table/table-header'
import TBody from 'components/shared/table/table-body'
import TRow from 'components/shared/table/table-row'
import TCol from 'components/shared/table/table-column'
import TablePagination from 'components/shared/table/table-pagination'
import SortedUp from 'components/shared/icons/sortedUp'
import SortedDown from 'components/shared/icons/sortedDown'
import SortIcon from 'components/shared/icons/sort'
import ColStatus from '../col-status'

const ProposalList = ({ selectedVenue, headers, list, sort, page, limit, total, fetchProposals, pageProposals, sortProposals, handleSwitchContent }) => {
  useEffect(() => { fetchProposals({ selectedVenue }) }, [selectedVenue, page, limit, sort])

  return (
    <div className="merchant-proposal-list">
      <div className="overflow-auto mt-5">
        <Table classes="w-full border-collapse">
          <THead classes="text-xs bg-lightgray font-semibold">
                {headers.map((header, key) => {
                  let sortIcon = <SortIcon />
                  let nextOrder = 'desc'

                  if (sort.field === header.field) {
                    if (sort.order === 'desc') {
                      sortIcon = <SortedDown />
                      nextOrder = 'asc'
                    } else {
                      sortIcon = <SortedUp />
                    }
                  }

                  return (
                  <TCol
                    classes="p-3 text-primary-black"
                    key={key}
                    align={header.align || 'left'}
                    onClick={() => header.sortable && sortProposals({ field: header.field, order: nextOrder })}
                  >
                    <div
                      className={`flex items-center gap-1 ${header.sortable ? 'cursor-pointer' : ''}`}
                    >
                      {header.name} {header.sortable && sortIcon}
                    </div>
                  </TCol>
                )
              })}
          </THead>
          <TBody>
            {list.map(item => (
              <TRow classes="border-t text-sm hover:bg-gray-100"
                key={item.id}>
                <TCol classes="p-3">{item.createDate}</TCol>
                <TCol classes="p-3">{item.date}</TCol>
                <TCol classes="p-3">{item.client}</TCol>
                <TCol classes="p-3 text-primary-orange">
                  <a href={item.spaceLink}>{item.space}</a>
                </TCol>
                <ColStatus classes="p-3 text-xs font-semibold" status={item.status} />
                <TCol classes="p-3" align="left">
                  <ul className="flex font-semibold text-center text-primary-orange">
                    <li className="">
                      <Link to={`/merchant/messages/${item.conversation_id}/conversation`} target="_blank">Message</Link>
                    </li>
                    <li className="text-primary-black px-2 font-thin">|</li>
                    <li onClick={() => handleSwitchContent({ value: 'edit-proposal', data: { ...item.proposal, id: item.id } })} className="cursor-pointer">
                      View Proposal
                    </li>
                  </ul>
                </TCol>
              </TRow>
            ))}
          </TBody>
        </Table>
      </div>
      <TablePagination
          currentPage={page}
          onPageChange={(newPage) => pageProposals({ page: newPage })}
          onPageSizeChange={(newPageSize) => pageProposals({ limit: newPageSize })}
          pageSize={limit}
          totalCount={total}
          className="mt-5"
        />
    </div>
  )
}

ProposalList.propTypes = {
  selectedVenue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  headers: PropTypes.array.isRequired,
  fetchProposals: PropTypes.func.isRequired,
  handleSwitchContent: PropTypes.func.isRequired,
  list: PropTypes.array,
  page: PropTypes.number.isRequired,
  limit: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  pageProposals: PropTypes.number.isRequired,
  sort: PropTypes.object.isRequired,
  sortProposals: PropTypes.func.isRequired,
}

const mapStateToProps = ({ bookings }) => ({
  headers: bookings.merchant.proposals.headers,
  list: bookings.merchant.proposals.list,
  page: bookings.merchant.proposals.page,
  limit: bookings.merchant.proposals.limit,
  total: bookings.merchant.proposals.total,
  sort: bookings.merchant.proposals.sort,
})

const mapDispatchToProps = {
  fetchProposals: bookingActions.fetchMerchantProposals,
  pageProposals: bookingActions.pageMerchantProposals,
  sortProposals: bookingActions.sortMerchantProposals,
}

export default connect(mapStateToProps, mapDispatchToProps)(ProposalList)
